import { Link } from "react-router-dom";
import { NadiaAvatar } from "@/components/nadia/NadiaAvatar";

/** Shared shell for Registrati / Accedi / Password pages — same premium dark look, no redesign. */
export function AuthShell({ eyebrow, title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen px-4 py-10 lg:py-16 flex items-start justify-center">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 mb-8" data-testid="auth-home-link">
          <NadiaAvatar size="md" />
          <div>
            <div className="font-heading text-sm font-bold text-slate-50 leading-tight">Nadia Cloud</div>
            <div className="text-[11px] text-slate-400">Direttore Marketing AI</div>
          </div>
        </Link>
        <div className="text-[11px] font-semibold uppercase tracking-[0.2em] text-cyan-300/80">{eyebrow}</div>
        <h1 className="mt-2 font-heading text-3xl sm:text-4xl font-extrabold tracking-tight leading-[1.1] text-slate-50" data-testid="auth-title">{title}</h1>
        {subtitle && <p className="mt-2 text-sm text-slate-400">{subtitle}</p>}
        <div className="nadia-card p-6 mt-6">{children}</div>
        {footer && <div className="mt-4 text-center text-xs text-slate-500">{footer}</div>}
        <div className="mt-6 text-center text-[11px] text-slate-600" data-testid="brand-line">Nadia Cloud · support@nadiacloud.it</div>
      </div>
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <label className="block">
      <div className="text-[11px] uppercase tracking-wider text-slate-400 font-semibold mb-1.5">{label}</div>
      {children}
    </label>
  );
}

export const inputCls = "h-11 bg-[#0B1120] border-white/10 text-slate-100 focus-visible:ring-cyan-400 focus-visible:ring-offset-0";
